export default __webpack_public_path__ + "src/images/packages/bakubung-villas/10095e74bf585b0889bd4f7d34daf690-5.jpg";